<script lang="ts">
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { z } from 'zod';

    import { SettingsApi } from '../../Settings/SettingsApi';
    import { planning } from '../../../../stores/store.js';
    import Checkbox from '../../../shared/Checkbox/Checkbox.svelte';
    import { api } from '../../../../stores/api';

    type SwitchQuickCategoryType = 'hide' | 'opacity';

    let checked: boolean = $planning.quickCategoryHideMethod === 'hide';
    let savedQuickCategoryHideMethod: SwitchQuickCategoryType = $planning.quickCategoryHideMethod;

    onMount(() => {
        (async () => {
            const settings = await SettingsApi.getClientSettings(
                $api,
                'quickCategoryHideMethod',
                z.string().catch('')
            ).catch(e => {
                console.warn(e);
            });
            if (settings !== undefined) {
                $planning.quickCategoryHideMethod = settings as SwitchQuickCategoryType;
            }
            checked = settings === 'hide';
        })();
    });

    $: {
        $planning.quickCategoryHideMethod = checked ? 'hide' : 'opacity';
        if (savedQuickCategoryHideMethod !== $planning.quickCategoryHideMethod) {
            (async () => {
                await SettingsApi.setClientSettings(
                    $api,
                    'quickCategoryHideMethod',
                    $planning.quickCategoryHideMethod,
                    z.string()
                );
                savedQuickCategoryHideMethod = $planning.quickCategoryHideMethod;
            })();
        }
    }
</script>

<Checkbox label={$_('hide_filtered')} bind:checked />
